export function findParents(data, targetTitle) {
  const path = [];

  function recursiveFind(node, targetTitle) {
    if (node.title === targetTitle) {
      path.push(node.title);
      return true;
    }

    if (node.subPages) {
      for (const subPage of node.subPages) {
        if (recursiveFind(subPage, targetTitle)) {
          path.push(node.title);
          return true;
        }
      }
    }

    return false;
  }

  recursiveFind(data, targetTitle);
  return path.reverse();
}
